import * as React from "react";
import PropTypes from "prop-types";
import {
  DataGrid,
  useGridApiContext,
  GridEditSingleSelectCell,
  GridToolbarContainer,
} from "@mui/x-data-grid";

import { Box, Button, Paper, Stack, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import CustomInput from "../Components/CustomInput/CustomInput";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DraggableDialog from "../Components/CustomDialogs/DraggableDialog";
import DataGridcsar from "./Components/CSAR";
import Incometype from "./Components/Incometype";

import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import PlaylistAddRoundedIcon from "@mui/icons-material/PlaylistAddRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { genURL } from "../_getjson";
// import PropTypes from "prop-types"; // Remove if not used
import CustomBackdrop from "../Components/CustomBackdrop/Barckdrop";

// const styleMenu = { color: "black", cursor: "pointer" }

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  fontFamily: "Customfont",
}));
const Custombutton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(0.7),
  textAlign: "center",
  color: theme.palette.text.secondary,
  fontFamily: "Customfont",
  border: " 1px solid #eee",
  fontWeight: 400,
  cursor: "pointer",
}));
const CustomTypeEditComponent = (props) => {
  const apiRef = useGridApiContext();
  const handleValueChange = async () => {
    console.log("handleValueChange", props);
    console.log("handleValueChange", props.row);
    console.log("handleValueChange", apiRef);

    // await apiRef.current.setEditCellValue({
    //     id: props.id,
    //     field: 'refReportoptiontype',
    //     value: '',
    // });
  };
  return (
    <GridEditSingleSelectCell onValueChange={handleValueChange} {...props} />
  );
};
CustomTypeEditComponent.propTypes = {
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default function Salewithholding(arg) {
  const { userData, withholdingdefaultValue, recheckeddata, from } = arg;
  const [incometype, setIncometype] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [updaterows, setUpdaterows] = React.useState([]);
  //----------------------------alert ----------------------------
  const [title, setTitle] = React.useState("");
  const [buttontxt, setButtontxt] = React.useState("");
  const [openModle, setOpenModle] = React.useState(false);
  const [typeModle, setTypeModle] = React.useState(false);
  const [clickrowsID, setClickrowsID] = React.useState("");
  const [defaultinputValue, setDefaultinputValue] = React.useState("0");
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [openbackdrop, setopenbackdrop] = React.useState(false);
  React.useEffect(() => {
    sumtax();
    //  setRows(newState)
    return () => {};
  }, [rows]);

  React.useEffect(async () => {
    console.log("withholdingdefaultValue", withholdingdefaultValue);
    if (withholdingdefaultValue.length > 0) {
      await setRows(withholdingdefaultValue);
    }

    // return () => {

    // }
  }, [withholdingdefaultValue]);

  React.useEffect(async () => {
    //-----------CSARWTAX-----------------------

    console.log("recheckeddata", recheckeddata);
    if (recheckeddata.length > 0) {
      checkarWTax();
    }

    return () => {};
  }, [recheckeddata]);

  const checkarWTax = async () => {
    setopenbackdrop(true);

    let url = genURL(
      `/csarwtax/Search?Tablename=${from}&Docno=${recheckeddata[0].DOCNO}`
    );
    let rs = await axios.get(url, { timeout: 12000 });

    await console.log("recheckeddata genURL(url)", genURL(url));
    if (rs.data.length > 0) {
      console.log("recheckeddata", rs.data);
      let element = [];
      for (let index = 0; index < rs.data.length; index++) {
        let incometypename = await loadincometypenameData(
          rs.data[index].INCOMETYPE
        ).then((rs) => {
          return rs;
        });
        // url = `CSINCOMETYPE/Search?top=100&type=${val}&text=${Inputtext}`
        element.push({
          id: Number(index) + 1,
          no: rs.data[index].RUNNING,
          incometype: incometypename,
          incometypecode: rs.data[index].INCOMETYPE,
          createdate: rs.data[index].DOCDATE,
          arcode: rs.data[index].ARCODE,
          arname: rs.data[index].ARNAME,
          remark: rs.data[index].REMARK,
          rate: rs.data[index].WTAXRATE,
          beforetax: rs.data[index].BEFORETAX,
          tax: rs.data[index].WTAXAMOUNT,
        });
      }

      await setRows(element);
    } else {
      await setRows([]);
    }
    await setopenbackdrop(false);
  };
  const loadincometypenameData = async (val) => {
    let url = `CSINCOMETYPE/Search?Code=${val}`;

    let rs = await axios.get(genURL(url), { timeout: 12000 });
    let element = [];
    let nameTH = "";
    // await console.log("elementzzzzzzzzzzz rs.data.length", rs);
    if (rs.data.length > 0) {
      for (let index = 0; index < rs.data.length; index++) {
        nameTH = rs.data[index].MYNAMETH;
      }
    }
    return nameTH;
  };

  let idCounter = 0;
  const createRow = (data, empty) => {
    // ถ้ามีข้อมูลใน rows staet
    if (rows.length > 0) {
      const ids = rows.map((object) => {
        return object.id;
      });
      const max = Math.max(...ids);
      idCounter = max;
    }
    idCounter += 1;
    let lastdata;
    if (empty === true) {
      let newdata = data.reduce(
        (a, v) => ({
          ...a,
          [v]:
            v.search(/date/) > -1
              ? new Date()
              : v.search(/arcode/) > -1
              ? userData[0]
              : v.search(/arname/) > -1
              ? userData[1]
              : "",
        }),
        {}
      );

      lastdata = { ...newdata, id: idCounter };
    }

    return lastdata;
  };

  const columns = [
    { field: "id", headerName: "ID", width: 40 },
    {
      field: "no",
      headerName: "เลขที่",
      width: 200,
      editable: true,
      maxwidth: 200,
    },
    {
      field: "incometype",
      headerName: "ประเภทเงินได้",
      width: 200,
      editable: true,
      maxwidth: 200,
      editable: false,
      sortable: false,
    },
    {
      field: "incometypecode",
      headerName: "ประเภทเงินได้",
      width: 200,
      editable: true,
      maxwidth: 200,
      editable: false,
      sortable: false,
      hide: true,
    },
    {
      field: "incometypeaction",
      headerName: "",
      sortable: false,
      width: 34,
      renderCell: (params) => {
        const onClick = () => {
          setTypeModle("incometypeaction");
          setClickrowsID(params.id);
          setOpenModle(true);
        };
        return (
          <SearchRoundedIcon onClick={onClick} sx={{ cursor: "pointer" }}>
            Click
          </SearchRoundedIcon>
        );
      },
    },
    {
      field: "createdate",
      headerName: "ลงวันที่",
      type: "date",
      width: 110,
      editable: true,
    },
    {
      field: "arcode",
      headerName: "รหัสลูกค้า",
      width: 200,
      editable: true,
      // type: 'singleSelect',
      //  valueOptions: ardata,
      maxwidth: 200,
      editable: false,
      sortable: false,
      // hidden: true
    },
    {
      field: "araction",
      headerName: "",
      sortable: false,
      width: 34,
      renderCell: (params) => {
        //     console.log("params", params)
        const onClick = () => {
          setTypeModle("araction");
          setClickrowsID(params.id);
          setOpenModle(true);
        };
        return (
          <SearchRoundedIcon onClick={onClick} sx={{ cursor: "pointer" }}>
            Click
          </SearchRoundedIcon>
        );
      },
    },
    {
      field: "arname",
      headerName: "ชื่อผู้ซื้อ/ผู้รับบริการ",
      width: 200,
      editable: false,
    },
    {
      field: "remark",
      headerName: "หมายเหตุ",
      width: 200,
      editable: true,
    },
    {
      field: "rate",
      headerName: "อัตรา",
      width: 90,
      editable: false,
    },
    {
      field: "beforetax",
      headerName: "ยอดก่อนภาษี",
      width: 150,
      editable: true,
    },
    {
      field: "tax",
      headerName: "ภาษี",
      width: 150,
      editable: false,
    },
  ];
  const agreeonClick = (e) => {
    console.log("agreeonClick", e);
  };
  const Dataselect = async (e) => {
    setOpenModle(false);
    // console.log("Dataselect clickrowsID", clickrowsID)
    // console.log("Dataselect", e)
    // console.log("Dataselect  rows[clickrowsID]", rows)
    const newState = rows.map((obj) => {
      // 👇️ if id equals 2, update country property
      if (obj.id === clickrowsID) {
        if (typeModle === "araction") {
          return { ...obj, arcode: e[0].code, arname: e[0].arname };
        } else {
          return {
            ...obj,
            incometypecode: e[0].code,
            incometype: e[0].nameTH,
            rate: e[0].rate,
          };
        }
      }
      // 👇️ otherwise return object as is
      return obj;
    });
    console.log("Dataselect newState", newState);
    await setRows(newState);

    // setArdata(e)
  };
  React.useEffect(async () => {
    let newrows = 10;

    if (
      rows.length <= 0 &&
      recheckeddata.length <= 0 &&
      withholdingdefaultValue.length <= 0
    ) {
      let field = [];
      columns.forEach((element) => {
        if (element.field != "id") {
          field.push(element.field);
        }
      });

      for (let index = 0; index < newrows; index++) {
        setRows((prevRows) => [...prevRows, createRow(field, true)]);
      }
      console.log("useEffect rows.length<0 ", recheckeddata.length);
    }
    return () => {};
  }, [columns]);

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            startIcon={<PlaylistAddRoundedIcon />}
            size="small"
            onClick={handleAddRow}
            sx={styleMenu}
          >
            เพิ่มแถว
          </Button>
          <Button
            variant="outlined"
            startIcon={<DeleteOutlineRoundedIcon />}
            onClick={(e) => delData()}
            size="small"
            style={{ display: selectionModel.length > 0 ? "inherit" : "none" }}
            sx={styleMenu}
          >
            ลบแถว
          </Button>
          <Button
            variant="outlined"
            startIcon={<CheckCircleOutlineRoundedIcon />}
            size="small"
            // onClick={e => selectData()}
            style={{ display: selectionModel.length > 0 ? "inherit" : "none" }}
            sx={styleMenu}
          >
            ตกลง
          </Button>
          <GridToolbarDensitySelector sx={styleMenu} />
        </Stack>
      </GridToolbarContainer>
    );
  };
  const delData = async () => {
    const selectedIDs = new Set(selectionModel);
    // you can call an API to delete the selected IDs
    // and get the latest results after the deletion
    // then call setRows() to update the data locally here
    await setRows((r) => r.filter((x) => !selectedIDs.has(x.id)));
  };
  // เพิ่มแถวในตาราง
  const handleAddRow = () => {
    let field = [];
    columns.forEach((element) => {
      if (element.field != "id") {
        field.push(element.field);
      }
    });
    setRows((prevRows) => [...prevRows, createRow(field, true)]);
    // setTimeout(() => {
    //     console.log("handleAddRow", rows)
    // }, 300);
  };
  const processRowUpdate = async (newRow) => {
    console.log("DataGrid processRowUpdate", newRow);
    let newRowData = [];
    for (let index = 0; index < rows.length; index++) {
      if (newRow.id === rows[index].id) {
        if (Number(newRow.beforetax) > 0 && Number(newRow.rate) > 0) {
          let x = (
            Number(newRow.beforetax) *
            (Number(newRow.rate) / 100)
          ).toFixed(2);
          newRowData.push({
            araction: "",
            arcode: newRow.arcode,
            arname: newRow.arname,
            beforetax: newRow.beforetax,
            createdate: newRow.createdate,
            id: newRow.id,
            incometype: newRow.incometype,
            incometypeaction: newRow.incometypeaction,
            incometypecode: newRow.incometypecode,
            no: newRow.no,
            rate: newRow.rate,
            remark: newRow.remark,
            tax: x,
          });
          // setDefaultinputValue(Number(defaultinputValue) + x);
        } else {
          newRowData.push(newRow);
        }
      } else {
        newRowData.push(rows[index]);
      }
    }
    await setRows(newRowData);
    return newRow;
  };
  const sumtax = async () => {
    let sumarytax = 0;
    rows.forEach((element) => {
      sumarytax = sumarytax + Number(element.tax);
    });
    //  console.log("sumarytax", sumarytax);
    await setDefaultinputValue(sumarytax.toFixed(2));
  };
  const submitClick = async () => {
    const newState = [];

    rows.map((obj) => {
      // 👇️ if id equals 2, update country property
      if (obj.no !== "") {
        newState.push(obj);
      }
      //    // 👇️ otherwise return object as is
    });
    //console.log("submitClick", newState);

    arg.resdata(newState);

    arg.receivedwithholdingdeData(defaultinputValue.toFixed(2));
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12}>
            {rows.length > 0 ? (
              <div style={{ height: 400, width: "100%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  editMode="row"
                  rowHeight={38}
                  processRowUpdate={processRowUpdate}
                  checkboxSelection
                  disableSelectionOnClick
                  onSelectionModelChange={(newSelectionModel) => {
                    setSelectionModel(newSelectionModel);
                  }}
                  selectionModel={selectionModel}
                  onRowEditCommit={console.log("DataGrid onRowEditCommit")}
                  experimentalFeatures={{ newEditingApi: true }}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                />
              </div>
            ) : (
              "กำลังโหลด"
            )}
          </Grid>
          <Grid
            xs={12}
            container
            justifyContent="space-between"
            alignItems="center"
            flexDirection={{ xs: "column", sm: "row" }}
            sx={{ fontSize: "12px" }}
          >
            <Grid sx={{ order: { xs: 2, sm: 1 } }}>{/* <Item></Item> */}</Grid>
            <Grid container columnSpacing={1} sx={{ order: { xs: 1, sm: 2 } }}>
              <Grid item>
                <Custombutton id="autoclick" onClick={(e) => agreeonClick(e)}>
                  อัตโนมัติ
                </Custombutton>
              </Grid>
              <Grid item>
                <Custombutton id="submit" onClick={(e) => submitClick(e)}>
                  ตกลง
                </Custombutton>
              </Grid>
              <CustomInput
                label={"รวมยอดราคา"}
                id="sumprice"
                onBlur={(e) => console.log(e)}
                inputType={"number"}
                defaultValue={defaultinputValue.toString()}
              />
            </Grid>
          </Grid>
        </Grid>
        <DraggableDialog
          open={openModle}
          title={title}
          buttontxt={buttontxt}
          closeDialog={(_) => setOpenModle(false)}
        >
          {typeModle === "araction" ? (
            <DataGridcsar Dataselect={(e) => Dataselect(e)} />
          ) : (
            <Incometype Dataselect={(e) => Dataselect(e)} />
          )}
        </DraggableDialog>
        <CustomBackdrop open={openbackdrop} />
      </Box>
    </>
  );
}

Salewithholding.propTypes = {
  userData: PropTypes.string,
  withholdingdefaultValue: PropTypes.array,
  recheckeddata: PropTypes.array,
  from: PropTypes.string,
};
